type SwitchProps = {
  value: boolean;
  onPress: (newValue: boolean) => void;
  duration?: number;
  size?: 'default' | 'small';
  trackColors?: { on: string; off: string };
  accessibilityLabel?: string;
  disabled?: boolean;
};

export function Switch({
  value,
  onPress,
  duration = 400,
  size = 'default',
  accessibilityLabel,
  disabled = false,
}: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      aria-label={accessibilityLabel}
      disabled={disabled}
      onClick={() => onPress(!value)}
      className={`flex shrink-0 items-start rounded-full transition-colors ease-in-out ${
        size === 'small' ? 'h-6 w-12 p-1' : 'h-7 w-14 p-[5px] md:h-8 md:w-16'
      } ${value ? 'bg-brand-green' : 'bg-stone-300'} ${disabled ? 'cursor-not-allowed' : ''}`}
      style={{ transitionDuration: `${duration}ms` }}
    >
      <span
        className={`block aspect-square h-full rounded-full bg-white transition-transform ease-in-out ${
          value ? (size === 'small' ? 'translate-x-6' : 'translate-x-7 md:translate-x-8') : ''
        }`}
        style={{ transitionDuration: `${duration}ms` }}
      />
    </button>
  );
}
